module.exports = __webpack_public_path__ + "static/media/body_bkgrnd.f672ee1e.jpg";